module.exports = __webpack_public_path__ + "img/checklist-alternate.1b835595.svg";